import { UseQueryResult, useQuery } from '@tanstack/react-query';

// helpers
import { BaseError } from '../../helpers/BaseError';

// models
import { EmailTemplates } from '../../models/formula.model';

// services
import API from '../../services/api';

import emailTemplateKeys from './_queryKeys';

const getEmailTemplates = async (): Promise<EmailTemplates[]> => {
    const { data } = await API.fetchTemplates();
    return data;
};

export default function useQueryEmailTemplates(
    enabled: boolean = true,
): UseQueryResult<EmailTemplates[], BaseError> {
    return useQuery<EmailTemplates[], BaseError>({
        queryKey: emailTemplateKeys.templates,
        queryFn: () => getEmailTemplates(),
        staleTime: 2 * 60 * 60,
        enabled,
    });
}
